import { Input, Label } from "reactstrap";
import { ChangeEvent } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../../reduxToolkit/hooks";
import { filterGender, removeGender } from "../../../../../../reduxToolkit/reducers/eCommerce/filterSlice";
import { getGender } from "../../../../../../utils/ecommerce";

// This component renders a checkbox for each gender in the product item.
const GenderFilter = () => {

  const { productItem } = useAppSelector((state) => state.product);
  const gender = getGender(productItem);
  const dispatch = useAppDispatch();
  const { filter } = useAppSelector((state) => state.filterData);

  const handleCategory = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked === true) dispatch(filterGender(e.target.value));
    else dispatch(removeGender(e.target.value));
  };

  return (
    <div className="checkbox-animated mt-0">
      {gender.map((item, i) => (
        <Label className="d-block" key={i}>
          <Input className="checkbox_animated" defaultChecked={filter.brand.includes(item) ? true : false} type="checkbox" name="name" value={item} onChange={handleCategory} />
          {item}
        </Label>
      ))}
    </div>
  );
};

export default GenderFilter;